module.exports = __webpack_public_path__ + "static/img/office (7).a3546057.jpg";